import styled from "style/styled-components";
import Tag from "components/generic/Tag";

const FilterTag = styled(Tag)`
  background-color: ${({ theme }) => theme.color.background.secondary};
`;

export default FilterTag;
